export class SetActivityReasonForStoppingModel {
    constructor(comment?: string, requestStoppingReasonId?: number, approvedStoppedDate?: Date){
        this.comment = comment;
        this.requestStoppingReasonId = requestStoppingReasonId;
        this.approvedStoppedDate = approvedStoppedDate;
    }
    comment: string;
    requestStoppingReasonId: number;
    approvedStoppedDate: Date;
}